export const ORDEN_ESTADOS = [
  "PENDIENTE_ASIGNAR",
  "ASIGNADO",
  "EN_PREPARACION",
  "CON_ERROR",
  "PREPARADO",
  "CONTROLADO",
  "DESPACHADO"
];

export const BUCKET_ORDER = ["HOY", "AYER", "ÚLTIMA SEMANA", "ÚLTIMO MES", "ANTERIORES"];

export function ordenarEstados(estados = []) {
  const idx = new Map(ORDEN_ESTADOS.map((e,i)=>[e,i]));
  return [...estados].sort((a,b)=>(idx.get(a)??99)-(idx.get(b)??99));
}

/** Convierte un timestamp (Date, Firestore Timestamp, ms number, string) a Date o null */
function toDate(ts) {
  if (!ts) return null;
  if (ts?.seconds) return new Date(ts.seconds * 1000);
  const d = ts instanceof Date ? ts : new Date(ts);
  return isNaN(d.getTime()) ? null : d;
}

/** Fecha de creación/ingreso del pedido (referencia general) */
export function getPedidoDate(p) {
  return (
    toDate(p?.finFechaTS) ||
    (p?.finFecha ? toDate(`${p.finFecha}T00:00:00`) : null) ||
    toDate(p?.timestamps?.creado) ||
    toDate(p?.updatedAt) ||
    null
  );
}

/** Fecha en que el pedido entró a su estado actual (clave para agrupar/ordenar por bucket).
 * Usa el timestamp del estado (fecha de INGRESO real), igual que la vista de ventas —
 * no el finFecha (fecha de entrega que pone el vendedor), que agrupaba mal (HOY/AYER). */
export function getEstadoDate(p) {
  const estado = p?.estado || "PENDIENTE_ASIGNAR";
  return (
    toDate(p?.timestamps?.[estado]) ||
    toDate(p?.updatedAt) ||
    getPedidoDate(p)
  );
}

/** Convierte un timestamp (Date, Firestore Timestamp, ms number) a bucket de fecha */
export function bucketFecha(ts) {
  const d = toDate(ts);
  if (!d) return "ANTERIORES";
  const hoy = new Date(); hoy.setHours(0,0,0,0);
  const dCopy = new Date(d); dCopy.setHours(0,0,0,0);
  const dif = (hoy - dCopy) / 86400000;
  if (dif <= 0) return "HOY";
  if (dif <= 1) return "AYER";
  if (dif <= 7) return "ÚLTIMA SEMANA";
  if (dif <= 30) return "ÚLTIMO MES";
  return "ANTERIORES";
}

/**
 * Agrupa pedidos por estado y bucket de fecha (HOY/AYER/ÚLTIMA SEMANA/ÚLTIMO MES/ANTERIORES),
 * según la fecha en que cada pedido entró a su estado actual. Dentro de cada bucket,
 * ordena de más reciente a más antiguo.
 */
export function agruparPorEstadoYFecha(pedidos = []) {
  const out = {};
  for (const p of pedidos) {
    const est = p.estado || "PENDIENTE_ASIGNAR";
    const fecha = bucketFecha(getEstadoDate(p));
    out[est] ||= {};
    out[est][fecha] ||= [];
    out[est][fecha].push(p);
  }
  for (const est of Object.keys(out)) {
    for (const bucket of Object.keys(out[est])) {
      out[est][bucket].sort((a, b) => (getEstadoDate(b)?.getTime() ?? 0) - (getEstadoDate(a)?.getTime() ?? 0));
    }
    const ordered = {};
    for (const key of BUCKET_ORDER) if (out[est][key]) ordered[key] = out[est][key];
    for (const key of Object.keys(out[est])) if (!(key in ordered)) ordered[key] = out[est][key];
    out[est] = ordered;
  }
  return out;
}
